import * as React from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "@common/lib/utils"
import { CONTROL_SURFACE, type ControlSize, controlSize } from "./control"
import { INPUT_FOCUS } from "./input"

const FieldTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { size?: ControlSize }
>(({ className, size, children, type = "button", ...props }, ref) => (
  <button
    ref={ref}
    type={type}
    className={cn(
      "flex items-center gap-2 text-left [&>svg]:size-4 [&>svg]:shrink-0",
      controlSize({ size }),
      CONTROL_SURFACE,
      INPUT_FOCUS,
      className
    )}
    {...props}
  >
    {children}
    <ChevronDown className="ml-auto opacity-50" />
  </button>
))
FieldTrigger.displayName = "FieldTrigger"

export { FieldTrigger }
